import { useEffect, useState } from "react";
import api from "../../../../../../features/auth/axiosConfig";

export function useLedger(customerId?: string) {
  const [outstandingBalance, setOutstandingBalance] = useState<number | string>(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!customerId) return;

    const fetchLedger = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/pos/ledger/customer/${customerId}`);
        const ledger = res.data.ledger;

        if (Array.isArray(ledger)) {
          const balances = ledger.map((i: { total_outstanding_balance: number }) => i.total_outstanding_balance);
          setOutstandingBalance(balances[0] ?? 0);
        } else {
          setOutstandingBalance(ledger?.total_outstanding_balance ?? 0);
        }
      } catch (error) {
        console.error("Error fetching ledger:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLedger();
  }, [customerId]);

  return { outstandingBalance, loading };
}
